export default [
  {
    path: '/v2/data-input/overall-budget',
    name: '总体预算',
    component: () => import (`@/views/data-input/overall-budget.vue`),
    meta: {
      permission: ['hr_wage_new_report_data_center_zl']
    }
  },
  {
    path: '/v2/data-input/employee-compensation',
    name: '员工薪酬水平',
    component: () => import (`@/views/data-input/employee-compensation.vue`),
    meta: {
      permission: ['hr_wage_new_report_data_center_zl']
    }
  }
]
